import { render, staticRenderFns } from "./tabContent.vue?vue&type=template&id=0ad99e34&"
import script from "./tabContent.vue?vue&type=script&lang=js&"
export * from "./tabContent.vue?vue&type=script&lang=js&"
import style0 from "./tabContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports